import { useEffect, useMemo, useState } from 'react';
import { Button, Popconfirm, Space } from 'antd';
import _ from 'lodash';
import VoucherService from 'services/voucher';
import { formatCurrency } from 'utils/number';
import { formatDate } from 'utils/date';
import { useApp } from 'contexts/app';

const service = new VoucherService();

const useList = () => {
  const { showNotify } = useApp();
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [voucherID, setVoucherID] = useState(false);

  const loadData = async (info) => {
    const list = await service.list({ info });
    setData(Array.isArray(list) ? list : []);
  };

  useEffect(() => {
    loadData();
  }, []);

  const onSearch = (text) => {
    loadData(text);
  };

  const searchDelay = useMemo(() => _.debounce(onSearch, 500), []);

  useEffect(() => {
    return () => {
      searchDelay.cancel();
    };
  }, [searchDelay]);

  const openVoucher = (id) => {
    setVoucherID(id);
    setIsModalOpen(true);
  };

  const onSearchChange = (e) => {
    searchDelay(e.target.value);
  };

  const copyVoucherCode = async (text) => {
    await window.navigator.clipboard.writeText(text);
    showNotify(`Đã copy ${text}`);
  };

  const deleteVoucher = async (id) => {
    await service.delete(id);
    loadData();
  };

  const onVoucherSaved = () => {
    loadData();
  };

  const columns = [
    {
      title: 'Voucher',
      render: (record) => (
        <Space>
          <Button onClick={() => openVoucher(record.id)} type='link'>{record.code}</Button>
          <Button type='link' onClick={() => copyVoucherCode(record.code)}>copy</Button>
        </Space>
      ),
    },
    {
      title: 'Mô tả',
      render: (record) => record.description,
    },
    {
      title: 'Ngày tạo',
      render: (record) => formatDate(record.create_on),
    },
    {
      title: 'Giá trị',
      render: (record) => {
        if (record.type === 'fixed') {
          return formatCurrency(record.value);
        }
        return `${formatCurrency(record.value)} %`;
      },
    },
    {
      title: 'Sử dụng',
      render: (record) => (
        <Space direction='vertical'>
          <div>Đã sử dụng {record.usages.length} / {record.usage_limit}</div>
          {record.usages.map((usage) => (
            <div key={usage.order_id}>{usage.order_id}</div>
          ))}
        </Space>
      ),
    },
    {
      title: '',
      render: (record) => (
        <Space direction='vertical'>
          <Popconfirm
            title='Xoá'
            description='Bạn có chắc chăn muốn xoá?'
            onConfirm={() => deleteVoucher(record.id)}
            okText='Yes'
            cancelText='No'
          >
            <Button type='link'>Delete</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return {
    data,
    isModalOpen,
    voucherID,
    setIsModalOpen,
    openVoucher,
    onSearch,
    onSearchChange,
    onVoucherSaved,
    columns,
    copyVoucherCode,
    deleteVoucher,
  };
};

export default useList;